import Sentry from './sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './views/utils/Global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CartProvider } from './context/cartContext';
import { AuthProvider } from './context/authContext';
import { BonusProvider } from './context/bonusContext';
import { ThemeProvider } from './context/themeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p style={{ padding: 24 }}>Ocurrió un error. Recarga la página.</p>}>
      <ThemeProvider>
        <AuthProvider>
          <BonusProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </BonusProvider>
        </AuthProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
